module.exports = __webpack_public_path__ + "img/phishing.6dfb2b5e.svg";